import { useQuery } from 'react-query';

import { useVendorApi } from './api';
import { vendorKeys } from '@config/queryKeys';

type Options = {
  vendorId?: string;
};
export default function useVendorMap({ vendorId }: Options = {}) {
  const api = useVendorApi();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery<
    ItemMap,
    any
  >(vendorKeys.map(vendorId), () => api.getMap(vendorId!), {
    enabled: !!vendorId,
  });

  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    map: data ?? ({} as ItemMap),
  };
}
